import "./DescriptorList.scss";

import DescriptorList from "./DescriptorList";

export default DescriptorList;
